// Walking Bucket — Single Page Store JS

document.addEventListener('DOMContentLoaded', function () {

  // CUSTOM CURSOR
  const cur = document.getElementById('cur');
  if (cur) {
    document.addEventListener('mousemove', function(e) {
      cur.style.left = e.clientX + 'px';
      cur.style.top = e.clientY + 'px';
    });
    document.querySelectorAll('a, button, .gallery-item, .campaign-main, .campaign-thumb').forEach(function(el) {
      el.addEventListener('mouseenter', function() { cur.classList.add('big'); });
      el.addEventListener('mouseleave', function() { cur.classList.remove('big'); });
    });
  }

  // STICKY NAV
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // SCROLL REVEAL
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.06 });
    revealEls.forEach(function(el) { observer.observe(el); });
  }

  // SMOOTH SCROLL
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // AJAX ADD TO CART → opens cart drawer
  const form = document.getElementById('product-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = document.getElementById('atc-btn');
      const formData = new FormData(form);

      btn.textContent = 'Adding...';
      btn.style.opacity = '0.7';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        btn.textContent = '✓ Added to Cart';
        btn.style.background = '#2D7A1F';
        btn.style.opacity = '1';
        setTimeout(function() {
          btn.textContent = 'Pre-Sale Now — $105';
          btn.style.background = '';
        }, 2500);
        openCart();
        refreshCart();
      })
      .catch(function(err) {
        btn.textContent = 'Error — Try Again';
        btn.style.opacity = '1';
        console.error(err);
      });
    });
  }

});

// CART DRAWER
function openCart() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (drawer && overlay) {
    overlay.style.display = 'block';
    drawer.style.right = '0';
    refreshCart();
  }
}

function closeCart() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (drawer && overlay) {
    drawer.style.right = '-500px';
    overlay.style.display = 'none';
  }
}

function refreshCart() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCart(cart);
      // update header btn
      const headerBtns = document.querySelectorAll('.cart-btn');
      headerBtns.forEach(function(btn) {
        if (cart.item_count > 0) {
          btn.textContent = 'Cart (' + cart.item_count + ')';
          btn.href = '#';
          btn.onclick = function(e) { e.preventDefault(); openCart(); };
        }
      });
    });
}

function renderCart(cart) {
  const itemsEl = document.getElementById('cart-items');
  const footerEl = document.getElementById('cart-footer');
  if (!itemsEl || !footerEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<p style="font-family:\'Barlow Condensed\',sans-serif;font-size:16px;opacity:.4;letter-spacing:.1em;">Your cart is empty.</p>';
    footerEl.innerHTML = '';
    return;
  }

  let html = '';
  cart.items.forEach(function(item) {
    html += '<div style="display:flex;gap:16px;padding:16px 0;border-bottom:1px solid rgba(255,255,255,.08);align-items:center;">';
    if (item.image) {
      html += '<img src="' + item.image + '" style="width:80px;height:80px;object-fit:cover;flex-shrink:0;">';
    }
    html += '<div style="flex:1;">';
    html += '<div style="font-family:\'Bebas Neue\',sans-serif;font-size:18px;letter-spacing:.05em;">' + item.product_title + '</div>';
    html += '<div style="font-family:\'Barlow Condensed\',sans-serif;font-size:13px;opacity:.4;margin:3px 0;">Size: ' + item.variant_title + '</div>';
    html += '<div style="font-family:\'Barlow Condensed\',sans-serif;font-size:16px;color:#E8621A;">' + formatMoney(item.line_price) + '</div>';
    html += '</div>';
    html += '<button onclick="removeItem(' + item.key + ')" style="background:none;border:none;color:#F0EAE0;opacity:.3;cursor:pointer;font-size:18px;padding:4px;">✕</button>';
    html += '</div>';
  });
  itemsEl.innerHTML = html;

  footerEl.innerHTML =
    '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">' +
    '<span style="font-family:\'Barlow Condensed\',sans-serif;font-size:14px;letter-spacing:.2em;text-transform:uppercase;opacity:.5;">Total</span>' +
    '<span style="font-family:\'Bebas Neue\',sans-serif;font-size:28px;color:#E8621A;">' + formatMoney(cart.total_price) + '</span>' +
    '</div>' +
    '<a href="/checkout" style="display:block;background:#E8621A;color:#080808;text-align:center;text-decoration:none;padding:20px;font-family:\'Bebas Neue\',sans-serif;font-size:22px;letter-spacing:.15em;width:100%;">Checkout</a>' +
    '<p style="font-family:\'Barlow Condensed\',sans-serif;font-size:11px;letter-spacing:.2em;opacity:.3;text-align:center;margin-top:12px;text-transform:uppercase;">Secure checkout via Shopify</p>';
}

function removeItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    renderCart(cart);
    const headerBtns = document.querySelectorAll('.cart-btn');
    headerBtns.forEach(function(btn) {
      if (cart.item_count > 0) {
        btn.textContent = 'Cart (' + cart.item_count + ')';
      } else {
        btn.textContent = 'Pre-Sale — $105';
      }
    });
  });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}
